<div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown" *ngIf="selectedCategory">
  <button class="btn btn-sm btn-primary capitalize" id="dropdownManual" ngbDropdownToggle type="button">
    {{ selectedCategory.name }}
  </button>
  <div ngbDropdownMenu aria-labelledby="dropdownManual">
    <button (click)="onTriggerCategoryChanged(triggerCategory)"
            type="button"
            class="dropdown-item capitalize"
            *ngFor="let triggerCategory of triggerCategories">
      {{ triggerCategory.name }}
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/trigger-categories/trigger-categories.component.html